import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '@/hooks/useAuth';

interface AuthCheckProps {
  children: React.ReactNode;
}

const PUBLIC_ROUTE_PREFIXES = ['/auth', '/u/', '/healthz'];

export function AuthCheck({ children }: AuthCheckProps) {
  const { user, loading: authLoading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const isPublicRoute = PUBLIC_ROUTE_PREFIXES.some((route) =>
    location.pathname.startsWith(route)
  );

  // Redirect unauthenticated users away from private routes only.
  // All onboarding redirection is now handled inside the onboarding pages themselves
  // to avoid global redirect loops and history.replaceState errors.
  useEffect(() => {
    if (!authLoading && !user && !isPublicRoute) {
      navigate('/auth', { replace: true });
    }
  }, [authLoading, user, isPublicRoute, navigate]);

  if (authLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  }

  // While redirecting to /auth, render nothing to avoid flicker
  if (!user && !isPublicRoute) {
    return null;
  }

  return <>{children}</>;
}
